import React from "react";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
// icons
import * as faFacebookSquare from "@fortawesome/fontawesome-free-brands/faFacebookSquare";
import * as faLinkedin from "@fortawesome/fontawesome-free-brands/faLinkedin";
import * as faTwitterSquare from "@fortawesome/fontawesome-free-brands/faTwitterSquare";
import * as faInstagram from "@fortawesome/fontawesome-free-brands/faInstagram";

const SocialMediaLinks = ({ color = "#000" }) => {
  const groupStyle = { fontSize: 28 };
  const socialLinkStyle = { margin: 5, color };

  return (
    <div style={groupStyle}>
      <a
        href="https://twitter.com/artflychris"
        style={socialLinkStyle}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faTwitterSquare} />
      </a>

      <a
        href="https://www.facebook.com/artfly.io/"
        target="_blank"
        style={socialLinkStyle}
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faFacebookSquare} />
      </a>

      <a
        href="https://www.instagram.com/artfly.io/"
        target="_blank"
        style={socialLinkStyle}
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faInstagram} />
      </a>

      <a
        href="https://www.linkedin.com/in/chris-dennett-1b69aa47/"
        target="_blank"
        style={socialLinkStyle}
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={faLinkedin} />
      </a>
    </div>
  );
};

export default SocialMediaLinks;



// WEBPACK FOOTER //
// ./src/components/socialMediaStuff/SocialMediaLinks.js